var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-surface-secondary w-100" }, [
    _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
      _c("div", { staticClass: "container-fluid py-4" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
              _c("div", [
                _c("button", {
                  staticClass: "btn-close text-xs",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({ name: "Reports" })
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vr opacity-20 my-1" }),
              _vm._v(" "),
              _c("h1", { staticClass: "h4 ls-tight" }, [
                _vm._v("Reporte facturación"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid vstack gap-5" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              {
                staticClass: "row",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.FILTER()
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Cliente"),
                    ]),
                    _vm._v(" "),
                    _c("search-user", {
                      attrs: { clearable: "" },
                      on: {
                        set_value: function (e) {
                          return (_vm.filter.user_id = e)
                        },
                      },
                      model: {
                        value: _vm.filter.user,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "user", $$v)
                        },
                        expression: "filter.user",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Estado"),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "form-control form-control-sm",
                      attrs: {
                        multiple: "",
                        items: _vm.states,
                        "item-value": "id",
                        "item-text": "name",
                        "hide-details": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.filter.state_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "state_id", $$v)
                        },
                        expression: "filter.state_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" },
                  [
                    _c("small", { staticClass: "input-title" }, [
                      _vm._v("Estado de pago"),
                    ]),
                    _vm._v(" "),
                    _c("v-select", {
                      staticClass: "form-control form-control-sm",
                      attrs: {
                        multiple: "",
                        items: _vm.payment_states,
                        "item-value": "id",
                        "item-text": "name",
                        "hide-details": "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.filter.payment_state_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "payment_state_id", $$v)
                        },
                        expression: "filter.payment_state_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }),
                _vm._v(" "),
                _vm.filter.date_range == "date_range"
                  ? _c(
                      "div",
                      { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Fecha desde"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "close-on-content-click": false,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "auto",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                value: _vm.filter.start_date,
                                                "hide-details": "",
                                                dense: "",
                                                readonly: "",
                                                clearable: "",
                                              },
                                              on: {
                                                "click:clear": function (
                                                  $event
                                                ) {
                                                  _vm.filter.start_date = ""
                                                },
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3347901366
                            ),
                            model: {
                              value: _vm.menu_start,
                              callback: function ($$v) {
                                _vm.menu_start = $$v
                              },
                              expression: "menu_start",
                            },
                          },
                          [
                            _vm._v(" "),
                            _c("v-date-picker", {
                              attrs: {
                                "no-title": "",
                                scrollable: "",
                                max: _vm.filter.end_date,
                              },
                              on: {
                                input: function ($event) {
                                  _vm.menu_start = false
                                },
                              },
                              model: {
                                value: _vm.filter.start_date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filter, "start_date", $$v)
                                },
                                expression: "filter.start_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filter.date_range == "date_range"
                  ? _c(
                      "div",
                      { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Fecha hasta"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "close-on-content-click": false,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "auto",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                value: _vm.filter.end_date,
                                                "hide-details": "",
                                                dense: "",
                                                readonly: "",
                                                clearable: "",
                                              },
                                              on: {
                                                "click:clear": function (
                                                  $event
                                                ) {
                                                  _vm.filter.end_date = ""
                                                },
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1491432502
                            ),
                            model: {
                              value: _vm.menu_end,
                              callback: function ($$v) {
                                _vm.menu_end = $$v
                              },
                              expression: "menu_end",
                            },
                          },
                          [
                            _vm._v(" "),
                            _c("v-date-picker", {
                              attrs: {
                                "no-title": "",
                                scrollable: "",
                                min: _vm.filter.start_date,
                                max: _vm.now,
                              },
                              on: {
                                input: function ($event) {
                                  _vm.menu_end = false
                                },
                              },
                              model: {
                                value: _vm.filter.end_date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filter, "end_date", $$v)
                                },
                                expression: "filter.end_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 mt-3" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" }, [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-h px-3 btn-primary w-100",
                        attrs: {
                          type: "submit",
                          disabled: _vm.loading == "filter",
                        },
                      },
                      [
                        _vm.loading == "filter"
                          ? _c(
                              "div",
                              {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Loading..."),
                                ]),
                              ]
                            )
                          : _c("span", [_vm._v("Filtrar")]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" }, [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-h px-3 btn-danger w-100",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.CLEAR()
                          },
                        },
                      },
                      [
                        _vm.loading == "clear"
                          ? _c(
                              "div",
                              {
                                staticClass: "spinner-border spinner-border-sm",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Loading..."),
                                ]),
                              ]
                            )
                          : _c("span", [_vm._v("Limpiar")]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-3 pl-0 pr-0 pr-md-2 mb-2" },
                  [
                    _c("v-select", {
                      staticClass: "form-control form-control-sm",
                      attrs: {
                        items: _vm.date_ranges,
                        "item-value": "id",
                        "item-text": "name",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.filter.date_range,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "date_range", $$v)
                        },
                        expression: "filter.date_range",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            {
              staticClass:
                "card-header bg-white d-flex justify-content-between align-items-center",
            },
            [
              _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
              _vm._v(" "),
              _vm.hash
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-m px-3 btn-neutral",
                      attrs: {
                        href:
                          _vm.endpoint.slice(0, -6) +
                          "v1/reports/my/" +
                          _vm.hash,
                        target: "_blank",
                      },
                    },
                    [_c("i", { staticClass: "fas fa-print" })]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card-body p-0" }, [
            _vm.href
              ? _c(
                  "div",
                  { staticClass: "p-4", staticStyle: { height: "100vh" } },
                  [
                    _c("iframe", {
                      attrs: {
                        src: _vm.href,
                        frameborder: "0",
                        width: "100%",
                        height: "100%",
                        id: "report-iframe",
                      },
                    }),
                  ]
                )
              : _c(
                  "p",
                  { staticClass: "text-sm text-muted text-center mb-0 py-3" },
                  [_vm._v("No hay resultados.")]
                ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }